module.exports = __webpack_public_path__ + "img/add_btn@3x.52899997.png";